import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQuantcastComponent } from './simple-icons-quantcast.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQuantcastComponent ],
    exports:      [ SimpleIconsQuantcastComponent ],
    bootstrap:    []
})
export class SimpleIconsQuantcastModule {}
